import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const Footer = () => {
  return (
    <footer
      style={{
        background: "#0b8f85", // Updated background color
        color: "#ffffff",
        padding: "60px 0 0",
        marginTop: "80px",
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          padding: "0 20px",
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "40px",
            marginBottom: "40px",
          }}
        >
          {/* Brand Column */}
          <div>
            <div className="col-lg-3 col-6" style={{ paddingTop: "0" }}>
            <div id="logo_home">
              <h1 style={{ margin: 0 }}>
                <a
                  href="/"
                  title="Surgeazy"
                  style={{ color: "white", textDecoration: "none" }}
                >
                  Surgeazy
                </a>
              </h1>
            </div>
          </div>
            <p
              style={{
                color: "#c2c9d8",
                lineHeight: "1.7",
                marginBottom: "25px",
                fontSize: "1rem",
              }}
            >
              Connecting patients with trusted healthcare professionals. Book
              appointments instantly with verified doctors and specialists.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4
              style={{
                fontSize: "1.25rem",
                fontWeight: "700",
                marginBottom: "25px",
                background: "#ffd54f",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              Quick Links
            </h4>
            <ul style={{ listStyle: "none", padding: "0", margin: "0" }}>
              {[
                "Find Doctors",
                "Book Appointment",
                "Video Consult",
                "Health Packages",
              ].map((item, index) => (
                <li key={index} style={{ marginBottom: "12px" }}>
                  <a
                    href="#0"
                    style={{
                      color: "#c2c9d8",
                      textDecoration: "none",
                      transition: "all 0.3s ease",
                      display: "flex",
                      alignItems: "center",
                      fontSize: "0.98rem",
                    }}
                    onMouseOver={(e) => {
                      e.target.style.color = "#ffffff";
                      e.target.style.transform = "translateX(5px)";
                    }}
                    onMouseOut={(e) => {
                      e.target.style.color = "#c2c9d8";
                      e.target.style.transform = "translateX(0)";
                    }}
                  >
                    <span style={{ marginRight: "8px", fontSize: "0.85rem" }}>
                      ▶
                    </span>
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Specialties */}
          <div>
            <h4
              style={{
                fontSize: "1.25rem",
                fontWeight: "700",
                marginBottom: "25px",
                background: "#ffd54f",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              Specialties
            </h4>
            <ul style={{ listStyle: "none", padding: "0", margin: "0" }}>
              {[
                "Proctology",
                "Laparoscopy",
                "Gynaecology",
                "Vascular",
                "Aesthetics",
                "Orthopedics",
                "Fertility",
                "Weight Loss",
                "Dermatology",
              ].map((item, index) => (
                <li key={index} style={{ marginBottom: "10px" }}>
                  <a
                    href="#0"
                    style={{
                      color: "#c2c9d8",
                      textDecoration: "none",
                      transition: "all 0.3s ease",
                      fontSize: "0.95rem",
                    }}
                    onMouseOver={(e) => (e.target.style.color = "#ffffff")}
                    onMouseOut={(e) => (e.target.style.color = "#c2c9d8")}
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact & Newsletter */}
          <div>
            <h4
              style={{
                fontSize: "1.25rem",
                fontWeight: "700",
                marginBottom: "25px",
                background: "#ffd54f",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              Stay Updated
            </h4>

            {/* Contact Info */}
            <div style={{ marginBottom: "25px" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "12px",
                }}
              >
                <div
                  style={{
                    width: "32px",
                    height: "32px",
                    background: "rgba(13, 110, 253, 0.15)",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: "12px",
                    fontSize: "0.9rem",
                  }}
                >
                  📞
                </div>
                <div>
                  <div style={{ fontSize: "0.95rem", color: "#c2c9d8" }}>
                    Emergency
                  </div>
                  <div style={{ fontSize: "1.05rem", fontWeight: "600" }}>
                    080-6541-7705
                  </div>
                </div>
              </div>

              <div style={{ display: "flex", alignItems: "center" }}>
                <div
                  style={{
                    width: "32px",
                    height: "32px",
                    background: "rgba(13, 110, 253, 0.15)",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: "12px",
                    fontSize: "0.9rem",
                  }}
                >
                  ✉️
                </div>
                <div>
                  <div style={{ fontSize: "0.95rem", color: "#c2c9d8" }}>
                    Email
                  </div>
                  <div style={{ fontSize: "1.05rem", fontWeight: "600" }}>
                    help@Surgeazy.com
                  </div>
                </div>
              </div>
            </div>

            {/* Newsletter */}
            <div>
              <p
                style={{
                  color: "#c2c9d8",
                  fontSize: "0.95rem",
                  marginBottom: "15px",
                }}
              >
                Subscribe for health tips & updates
              </p>
              <div style={{ display: "flex", gap: "10px" }}>
                <input
                  type="email"
                  placeholder="Your email"
                  style={{
                    flex: "1",
                    padding: "12px 15px",
                    border: "none",
                    borderRadius: "8px",
                    background: "rgba(255,255,255,0.12)",
                    color: "white",
                    fontSize: "0.95rem",
                  }}
                />
                <button
                  style={{
                    padding: "12px 20px",
                    background:
                      "linear-gradient(135deg, #0d6efd 0%, #6610f2 100%)",
                    border: "none",
                    borderRadius: "8px",
                    color: "white",
                    fontWeight: "600",
                    cursor: "pointer",
                    transition: "transform 0.3s ease",
                    fontSize: "0.95rem",
                  }}
                  onMouseOver={(e) =>
                    (e.target.style.transform = "translateY(-2px)")
                  }
                  onMouseOut={(e) =>
                    (e.target.style.transform = "translateY(0)")
                  }
                >
                  Subscribe
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div
          style={{
            height: "1px",
            background:
              "linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.2) 50%, transparent 100%)",
            margin: "40px 0",
          }}
        ></div>

        {/* Bottom Footer */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "20px",
            paddingBottom: "40px",
          }}
        >
          <div style={{ display: "flex", gap: "30px", flexWrap: "wrap" }}>
            {["Terms & Conditions", "Privacy Policy", "Cookie Policy"].map(
              (item, i) => (
                <a
                  key={i}
                  href="#0"
                  style={{
                    color: "#c2c9d8",
                    textDecoration: "none",
                    fontSize: "0.95rem",
                    transition: "color 0.3s ease",
                  }}
                  onMouseOver={(e) => (e.target.style.color = "#fff")}
                  onMouseOut={(e) => (e.target.style.color = "#c2c9d8")}
                >
                  {item}
                </a>
              )
            )}
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              color: "#c2c9d8",
              fontSize: "0.95rem",
            }}
          >
            <span>© 2025 Surgeazy rights reserved</span>
            <div
              style={{
                width: "4px",
                height: "4px",
                background: "#0d6efd",
                borderRadius: "50%",
              }}
            ></div>
            <span>Made with ❤️ for better healthcare</span>
          </div>
        </div>
      </div>

      {/* Floating WhatsApp CTA */}
      <div
        style={{
          position: "fixed",
          bottom: "30px",
          right: "30px",
          zIndex: "1000",
        }}
      >
        <a
          href="https://wa.me/918888888888"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "60px",
            height: "60px",
            background: "#25D366",
            border: "none",
            borderRadius: "50%",
            color: "white",
            fontSize: "30px",
            cursor: "pointer",
            boxShadow: "0 8px 25px rgba(37, 211, 102, 0.5)",
            transition: "all 0.3s ease",
            textDecoration: "none",
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = "scale(1.1)";
            e.currentTarget.style.boxShadow =
              "0 12px 30px rgba(37, 211, 102, 0.7)";
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = "scale(1)";
            e.currentTarget.style.boxShadow =
              "0 8px 25px rgba(37, 211, 102, 0.5)";
          }}
        >
          <FaWhatsapp />
        </a>
      </div>
    </footer>
  );
};

export default Footer;
